module.exports = __webpack_public_path__ + "static/img/solution02.0438b038.webp";